<template>
  <div class="page">
    <main class="card">
      <div class="kicker">Angemeldet</div>
      <template v-if="loading">
        <h1 class="title">Lade Profil …</h1>
        <div class="spinner" aria-label="Lädt"></div>
      </template>

      <template v-else-if="user">
        <h1 class="title">Hallo, {{ user.userName }}</h1>
        <p class="subtitle">Sie sind angemeldet als <strong>{{ user.userName }}</strong>.</p>
        <button class="linkbtn" @click="onLogout">Abmelden</button>
      </template>

      <template v-else>
        <div class="error">Profil konnte nicht geladen werden.</div>
        <button class="linkbtn" @click="onLogout">Zurück zur Anmeldung</button>
      </template>
    </main>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { getCurrentUser, logout, type CurrentUser } from '../services/auth';

const user = ref<CurrentUser | null>(null);
const loading = ref(true);

onMounted(async () => {
  try {
    user.value = await getCurrentUser();
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
});

function onLogout() {
  // SSO-Logout: zerstört auch die OAuth-Server-Session, damit beim nächsten
  // „Anmelden" wieder Credentials eingegeben werden müssen (Kontowechsel möglich).
  logout('sso');
}
</script>
